import React, { useCallback } from 'react';
import { Divider } from 'theme/Global.styles';
import { Button } from 'theme/Button';
import { MD, SM } from '@zendeskgarden/react-typography';
import Flex from 'styled-flex-component';
import { Grid, Row, Col } from '@zendeskgarden/react-grid';
import { variables } from 'theme/variables';
import numeral from 'numeral';
import { ProductsSectionHeader } from 'routes/Products/Products.styles';
import { openModal } from 'state/modals/actions';
import { get, includes } from 'lodash';
import { productNominalDetailsShape } from 'propTypesObjects';
import { webRefactorSwitch } from 'utility/environment';
import { PropTypes } from 'prop-types';
import history from 'historyContainer';
import {
  HeaderMd,
  SubMd,
  NomLabel,
  ListingSizeAndStrength,
  Disclaimer,
  DisclaimerCol,
} from './ProductsNominalDetails.styles';

const { custom_silver: customSilver } = variables;

function ProductsNominalDetails({ productDetails, listingsRefactor }) {
  const {
    od,
    wall,
    min_yield: minYield,
    api_internal_pressure: apiInternalPressure,
    inside_diameter: insideDiameter,
    minimum_tensile_strength: minimumTensileStrength,
    collapse_pressure: collapsePressure,
    special_drift: specialDrift,
    drift,
  } = productDetails?.criteria || {};
  const lotSummary = get(productDetails?.result, 'lot_summary');
  const isDashboard = includes(
    history?.location?.pathname,
    '/dashboard/listings'
  );
  const isPreview = includes(history?.location?.pathname, '/preview');

  const renderDataRow = useCallback(() => {
    if (listingsRefactor && webRefactorSwitch) {
      return (
        <Row className="dataRow">
          <Col className="sizeCol">
            <HeaderMd bold>Size</HeaderMd>
            <Flex className="nomRow" alignCenter style={{ paddingTop: '10px' }}>
              <NomLabel grey>Nominal OD</NomLabel>
              <MD className="nomNum" bold>
                {' '}
                {od ? `${numeral(od).format('0.000')}" ` : '--'}{' '}
              </MD>
              {od && (
                <SM bold style={{ paddingLeft: '3px' }}>
                  in
                </SM>
              )}
            </Flex>
            <Flex className="nomRow" alignCenter style={{ paddingTop: '10px' }}>
              <NomLabel grey>Nominal ID</NomLabel>
              <MD className="nomNum" bold>
                {' '}
                {insideDiameter
                  ? `${numeral(insideDiameter).format('0.000')}"`
                  : '--'}{' '}
              </MD>
              {insideDiameter && (
                <SM bold style={{ paddingLeft: '3px' }}>
                  in
                </SM>
              )}
            </Flex>
            <Flex className="nomRow" alignCenter style={{ paddingTop: '10px' }}>
              <NomLabel grey>Nominal Wall Thickness</NomLabel>
              <MD className="nomNum" bold>
                {' '}
                {wall ? `${numeral(wall).format('0.000')}"` : '--'}{' '}
              </MD>
              {wall && (
                <SM bold style={{ paddingLeft: '3px' }}>
                  in
                </SM>
              )}
            </Flex>
            <Flex className="nomRow" alignCenter style={{ paddingTop: '10px' }}>
              <NomLabel grey>Drift</NomLabel>
              <MD className="nomNum" bold>
                {' '}
                {drift ? `${numeral(drift).format('0.000')}"` : '--'}{' '}
              </MD>
              {drift && (
                <SM bold style={{ paddingLeft: '3px' }}>
                  in
                </SM>
              )}
            </Flex>
            <Flex
              className="lastNomNum nomRow"
              alignCenter
              style={{ paddingTop: '10px' }}
            >
              <NomLabel grey>Special Drift</NomLabel>
              <MD className="nomNum" bold>
                {' '}
                {specialDrift
                  ? `${numeral(specialDrift).format('0.000')}"`
                  : '--'}{' '}
              </MD>
              {specialDrift && (
                <SM bold style={{ paddingLeft: '3px' }}>
                  in
                </SM>
              )}
            </Flex>
          </Col>

          <Col className="divider" size="3px">
            <Divider background={customSilver} />
          </Col>

          <Col className="strengthCol">
            <HeaderMd bold>Strength</HeaderMd>

            <Flex className="firstStrengthNum strengthRow" alignCenter>
              <SubMd grey>Minimum Yield Strength</SubMd>
              <MD className="strengthNum" bold>
                {' '}
                {minYield
                  ? `${numeral(minYield).format('0,0')} KSI`
                  : '--'}{' '}
              </MD>
            </Flex>

            <Flex className="secondDivider strengthRow" alignCenter>
              <SubMd grey>Minimum Ultimate Tensile Strength</SubMd>
              <MD className="strengthNum" bold>
                {' '}
                {minimumTensileStrength
                  ? `${numeral(minimumTensileStrength).format('0,0')} KSI`
                  : '--'}{' '}
              </MD>
            </Flex>

            <Flex
              className="strengthRow"
              alignCenter
              style={{ paddingTop: '10px', justifyContent: 'space-between' }}
            >
              <SubMd grey>Collapse Pressure</SubMd>
              <MD className="strengthNum" bold>
                {' '}
                {collapsePressure
                  ? `${numeral(collapsePressure).format('0,0')} PSI`
                  : '--'}{' '}
              </MD>
            </Flex>

            <Flex
              className="strengthRow"
              alignCenter
              style={{ paddingTop: '10px', justifyContent: 'space-between' }}
            >
              <SubMd grey>Internal / Burst Pressure</SubMd>
              <MD className="strengthNum" bold>
                {' '}
                {apiInternalPressure
                  ? `${numeral(apiInternalPressure).format('0,0')} PSI`
                  : '--'}{' '}
              </MD>
            </Flex>
          </Col>
        </Row>
      );
    }
    return (
      <Row>
        <Col style={{ maxWidth: '350px' }}>
          <HeaderMd bold>Size</HeaderMd>

          <Flex alignCenter style={{ paddingTop: '10px' }}>
            <NomLabel grey>Nominal OD</NomLabel>
            <MD bold>
              {' '}
              {od ? `${numeral(od).format('0.000')} inches` : '--'}{' '}
            </MD>
          </Flex>
          <Flex alignCenter style={{ paddingTop: '10px' }}>
            <NomLabel grey>Nominal ID</NomLabel>
            <MD bold>
              {' '}
              {insideDiameter
                ? `${numeral(insideDiameter).format('0.000')} inches`
                : '--'}{' '}
            </MD>
          </Flex>
          <Flex alignCenter style={{ paddingTop: '10px' }}>
            <NomLabel grey>Nominal Wall Thickness</NomLabel>
            <MD bold>
              {' '}
              {wall ? `${numeral(wall).format('0.000')} inches` : '--'}{' '}
            </MD>
          </Flex>
          <Flex alignCenter style={{ paddingTop: '10px' }}>
            <NomLabel grey>Drift</NomLabel>
            <MD bold>
              {' '}
              {drift ? `${numeral(drift).format('0.000')} inches` : '--'}{' '}
            </MD>
          </Flex>
          <Flex alignCenter style={{ paddingTop: '10px' }}>
            <NomLabel grey>Special Drift</NomLabel>
            <MD bold>
              {' '}
              {specialDrift
                ? `${numeral(specialDrift).format('0.000')} inches`
                : '--'}{' '}
            </MD>
          </Flex>
        </Col>

        <Col size="3px" style={{ paddingRight: '40px', maxWidth: '30px' }}>
          <Divider background={customSilver} />
        </Col>

        <Col style={{ maxWidth: '500px' }}>
          <HeaderMd bold>Strength</HeaderMd>

          <Flex alignCenter style={{ paddingTop: '10px' }}>
            <MD bold>
              {' '}
              {minYield ? `${numeral(minYield).format('0,0')} KSI` : '--'}{' '}
            </MD>
            <SubMd grey>Minimum Yield Strength</SubMd>
          </Flex>

          <Flex
            alignCenter
            style={{
              paddingTop: '10px',
              marginBottom: '4px',
              paddingBottom: '4px',
              borderBottom: `1px solid  ${customSilver}`,
              maxWidth: '60%',
            }}
          >
            <MD bold>
              {' '}
              {minimumTensileStrength
                ? `${numeral(minimumTensileStrength).format('0,0')} KSI`
                : '--'}{' '}
            </MD>
            <SubMd grey>Minimum Ultimate Tensile Strength</SubMd>
          </Flex>

          <Flex alignCenter style={{ paddingTop: '10px' }}>
            <MD bold>
              {' '}
              {collapsePressure
                ? `${numeral(collapsePressure).format('0,0')} PSI`
                : '--'}{' '}
            </MD>
            <SubMd grey>Collapse Pressure</SubMd>
          </Flex>

          <Flex alignCenter style={{ paddingTop: '10px' }}>
            <MD bold>
              {' '}
              {apiInternalPressure
                ? `${numeral(apiInternalPressure).format('0,0')} PSI`
                : '--'}{' '}
            </MD>
            <SubMd grey>Internal / Burst Pressure</SubMd>
          </Flex>
        </Col>
      </Row>
    );
  }, [
    apiInternalPressure,
    collapsePressure,
    drift,
    insideDiameter,
    minYield,
    minimumTensileStrength,
    od,
    specialDrift,
    wall,
    listingsRefactor,
  ]);

  return (
    <div style={{ position: 'relative' }}>
      <ListingSizeAndStrength
        horizontal
        newListings={listingsRefactor}
        isDashboard={isDashboard}
        isPreview={isPreview}
      >
        <div style={{ minWidth: '400px' }}>
          <Grid>
            <Row>
              <Col>
                {lotSummary && (
                  <ProductsSectionHeader tag="h2" paddingBottomMd scaled bold>
                    Pipe Body Technical Properties
                  </ProductsSectionHeader>
                )}
              </Col>
            </Row>
            {renderDataRow()}
          </Grid>
        </div>
      </ListingSizeAndStrength>
      <Grid
        style={{ marginTop: '20px', minWidth: '350px', marginBottom: '10px' }}
      >
        <Row>
          <DisclaimerCol>
            <Disclaimer grey notProd={webRefactorSwitch} isPreview={isPreview}>
              <span style={{ color: `black` }}>Disclaimer:</span> The burst and
              collapse figures displayed are based on the API dimension
              tolerance of 87.5% of nominal wall thickness. Note that
              martensitic, duplex, super duplex, and nickel alloys often have
              tighter dimensional tolerances, therefore, increased strength
              ratings. The properties do not factor connection performance
              ratings. If your application requires more information ratings,
              please{' '}
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  openModal({
                    type: 'contactUsModal',
                  });
                }}
                id="contactUs"
              >
                contact
              </Button>{' '}
              our technical services team, and we happily assist you.
            </Disclaimer>
          </DisclaimerCol>
        </Row>
      </Grid>
    </div>
  );
}

ProductsNominalDetails.propTypes = {
  productDetails: productNominalDetailsShape,
  listingsRefactor: PropTypes.bool,
};

export default ProductsNominalDetails;
